import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getMessage({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getMessage', () =>
      http.get(`message/DirectUserMessageGet?id=${id}`)
    )
    commit(types.SET_MESSAGE, r.data)
  },
  resetWorkOrderMessages({ commit, dispatch }) {
    commit(types.SET_WORK_ORDER_MESSAGES, null)
  },
  async getWorkOrderMessages({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderMessages', () =>
      http.get(`message/ServiceRequestMessages?id=${id}`)
    )
    commit(types.SET_WORK_ORDER_MESSAGES, r.data)
  },
  async getMessages({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getMessages', () =>
      http.get(`message/DirectUserMessageList`, {
        params: searchOptions
      })
    )
    commit(types.SET_MESSAGES, r.data)
  },
  async getAllMessages({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getAllMessages', () =>
      http.get(`message/DirectUserMessageList`, {
        params: searchOptions
      })
    )
    commit(types.SET_ALL_MESSAGES, r.data)
  },
  async getMessageCounts({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getMessageCounts', () =>
      http.get(`message/DirectUserMessageCount`, {
        params: data
      })
    )
    commit(types.SET_MESSAGE_COUNTS_WORKORDER, r.data)
    return r.data
  },
  async updateMessage({ commit, state, dispatch }, message) {
    await startLoading(dispatch, 'updateMessage', () =>
      http.post(`message/UpdateUserMessage`, message)
    )
  },
  async createMessage({ commit, state, dispatch }, message) {
    await startLoading(dispatch, 'createMessage', () =>
      http.post(`message/InsertUserMessage`, message)
    )
  },
  async replyMessage({ commit, state, dispatch }, message) {
    await startLoading(dispatch, 'replyMessage', () =>
      http.post(`message/InsertUserMessage`, message)
    )
    await startLoading(dispatch, 'updateMessage', () =>
      http.post(`message/UpdateUserMessage`, message)
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/actions.js